<template>
  <div class="invitationLetterIndex" @click="toClientLogin" v-move="{ start, move, end }">
    <div style="height: 90vh;position: relative;">
<!--      <img style="width: 100%;" :src="bgSrc" alt="">-->
    </div>
    <div style="height: 10vh;position: relative">
      <footer-message style="color: rgb(255, 255, 255);position: absolute;transform: scale(0.9);left: 0;font-size: 12px;width: 100vw;top:0;"></footer-message>
      <img :src="animationUrl" alt="" class="animationCss">
    </div>
  </div>
</template>

<script>

import footerMessage from '@/components/footer-message'
import {mapGetters} from 'vuex'
// import bgSrc from '@/assets/invitation-letter-background.jpg'
import animationUrl from '@/assets/2025/animation.gif'
import {Shares} from '@/util/Share'

export default {
  name: "invitationLetter2024", // 邀请函封面
  components: {footerMessage},
  data() {
    return {
      // bgSrc,
      animationUrl
    }
  },
  computed: {
    ...mapGetters(['clientId'])
  },
  methods: {
    toClientLogin() {
      this.$router.push({name: "clientLogin2024"})
    },
    start: function (e) {
      // console.log(e, 'start')
    },
    move: function (e) {
      // console.log(e, 'move')
    },
    end: function (e) {
      this.$router.push({name: "clientLogin2024"})
      // console.log(e, 'end')
    }
  },
  directives: {
    move: {
      bind: (el, binding) => {
        /**
         *  判断是PC端还是移动端
         *  通过不同的设备定义不同的事件名
         */
        const isMobile =
            navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            ) !== null
        const [start, move, end] = isMobile
            ? ['touchstart', 'touchmove', 'touchend']
            : ['mousedown', 'mousemove', 'mouseup']
        /**
         *  开始触摸
         *  执行触摸回调函数
         *  监听滑动事件
         *  监听触摸结束事件
         *  监听阻止移动端屏幕移动事件
         */
        const startFun = e => {
          binding.value.start(e)
          el.addEventListener(move, moveFun)
          el.addEventListener(end, endFun)
          window.addEventListener('touchmove', prevent, {
            passive: false
          })
        }
        /**
         *  开始滑动
         *  执行滑动回调函数
         */
        const moveFun = e => {
          binding.value.move(e)
        }
        /**
         *  结束触摸
         *  执行结束触摸回调函数
         *  销毁滑动事件
         *  销毁结束触摸事件
         *  销毁阻止移动屏幕事件
         */
        const endFun = e => {
          binding.value.end(e)
          el.removeEventListener(move, moveFun)
          el.removeEventListener(end, endFun)
          window.removeEventListener('touchmove', prevent)
        }
        /**
         *  阻止移动端屏幕移动
         */
        const prevent = e => {
          e.preventDefault()
        }
        /**
         *  监听触摸事件
         */
        el.addEventListener(start, startFun)
      }
    }
  },
  mounted() {
    Shares.shareCode()
  }
}
</script>

<style lang="less" scoped>
.invitationLetterIndex {
  position: relative;
  height: 100%;
  overflow: auto;
  background-color: #012478;
  background-image: url("../../assets/2025/index.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-color: rgba(46,97,188,1);

  .invitationLetterIndexBtnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .animationCss {
    position: absolute;
    width: 20vw;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
  }

  .animationC-border {
    border: 2px solid rgb(255, 255, 255);
    position: absolute;
    width: 30vw;
    transform: translate(-50%, 0);
    bottom: 2px;
    left: 50%;
    border-radius: 3px;
  }

}
</style>
